<nb-card>
  <nb-card-header>Projects</nb-card-header>
  <nb-card-body>
    <ngx-form-list *ngIf="projectColumns != null"
      [columns]="projectColumns"
      [(value)]="filteredProjects"
      (valueChange)="change($event)"
      (editConfirm)="validate($event)"
    >
    </ngx-form-list>
  </nb-card-body>
</nb-card>

